import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AdminComponent } from "./layout/admin/admin.component";
import { AuthComponent } from "./layout/auth/auth.component";
import { RouteGuard } from "./shared/route-guard/routeguarde.guard";

const routes: Routes = [
  {
    path: "admin",
    canActivate: [RouteGuard],
    component: AdminComponent,
    children: [
      {
        path: "",
        redirectTo: "dashboard",
        pathMatch: "full",
      },
      {
        path: "dashboard",
        loadChildren: "./theme/dashboard/default/default.module#DefaultModule",
      },
      // {
      //   path: 'blog',
      //   loadChildren: './theme/blog/blog.module#BlogModule'
      // },
      {
        path: "settings",
        loadChildren: "./theme/settings/settings.module#SettingsModule",
      },
      {
        path: "wiretransferclaims",
        loadChildren:
          "./theme/wire-transfer-claims/wire.transfer.claim.module#WireTransferClaimModule",
      },
      {
        path: "notifications",
        loadChildren:
          "./theme/notifications/notifications.module#NotificationsModule",
      },
      {
        path: "smartContract",
        loadChildren:
          "./theme/smart-contract/smart-contract.module#SmartContractModule",
      },
      {
        path: "bulkTokenTransfer",
        loadChildren:
          "./theme/bulk-token-transfer/bulk-token-transfer.module#BulkTokenTransferModule",
      },
      {
        path: "transactions",
        loadChildren:
          "./theme/transactions/transactions.module#TransactionsModule",
      },
      {
        path: "withdrawRequests",
        loadChildren:
          "./theme/withdraw-requests/withdraw-requests.module#WithdrawRequestsModule",
      },
      {
        path: "liquidityRewardClaims",
        loadChildren:
          "./theme/liquidity-reward-claims/liquidity-reward-claims.module#LiquidityRewardClaimsModule",
      },
      {
        path: "kycRewardClaims",
        loadChildren:
          "./theme/kyc-reward-claims/kyc-reward-claims.module#KYCRewardClaimsModule",
      },
      {
        path: "sendToken",
        loadChildren:
          "./theme/send-piptles/send-piptles.module#SendPiptlesModule",
      },
      {
        path: "blastMessage",
        loadChildren:
          "./theme/blast-message/blast-message.module#BlastMessageModule",
      },
      {
        path: "promoVideo",
        loadChildren: "./theme/promo-video/promo-video.module#PromoVideoModule",
      },
      {
        path: "affiliates",
        loadChildren: "./theme/affiliates/affiliates.module#AffiliatesModule",
      },
      // {
      //   path: 'earlyBirds',
      //   loadChildren: './theme/early-birds/early-birds.module#EarlyBirdsModule'
      // },
      {
        path: "newsletterSubscription",
        loadChildren:
          "./theme/newsletter-subscription/newsletter-subscription.module#NewsletterSubscriptionModule",
      },
      {
        path: "user",
        loadChildren: "./theme/user/user.module#UserModule",
      },
      {
        path: "kyc",
        loadChildren: "./theme/kyc/kyc.module#KycModule",
      },
      {
        path: "support",
        loadChildren: "./theme/support/support.module#SupportModule",
      },
    ],
  },
  {
    path: "",
    component: AuthComponent,
    loadChildren:
      "./theme/auth/login/basic-login/basic-login.module#BasicLoginModule",
  },
  {
    path: "deploy",
    component: AuthComponent,
    loadChildren:
      "./theme/auth/smart-contract-deployment/smart-contract-deployment.module#SmartContractDeploymentModule",
  },
  {
    path: "forgot",
    component: AuthComponent,
    loadChildren: "./theme/auth/forgot/forgot.module#ForgotModule",
  },
  {
    path: "verification",
    component: AuthComponent,
    loadChildren:
      "./theme/auth/verify-forgot/verifyforgot.module#VerifyForgotModule",
  },
  {
    path: "twofa",
    component: AuthComponent,
    loadChildren: "./theme/auth/twoFA/two.fa.module#TwoFAModule",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
